import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/omnitecActions'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

export const fetchOmnitecLocks = ourId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.OMNITEC_LOCKS_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.omnitecLocksFind, { organizationId: ourId }), auth, { method: 'GET' })
        // fetch(urlParams(urls.omnitecLocksFind, { organizationId: ourId }), { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_fetchLocksSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_fetchLocksFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/omnitecApi/omnitecLocks.js